<template>
  <div v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh"
  >
    <li class="nav-item dropdown" :class="[{'dropdown-hover': openInHover}]" :style="customStyle" v-if="!isSubmenu">
      <a class="nav-link" :class="[dropdown_icon, dropdown_drop, screenSizeId < 3 ? 'mobile-padding' : '']" href="#"
         role="button"
         :data-toggle="`${openInHover?null:'dropdown'}`" aria-haspopup="true" aria-expanded="false"
         :style="{'cursor':cursor}" @click.prevent="$emit('onClick')"
      >
        <div v-if="userMenu">{{ label }}
          <div v-show="!showAltIcon" :style="iconStyle">
            <i v-if="userIcon" :class="userIcon"></i>
          </div>
          <div v-show="showAltIcon" :style="iconStyle">
            <i v-if="altUserIcon" :class="altUserIcon"></i>
          </div>
        </div>
        <div v-else>{{ label }} <i :class="[classIcon]" v-show="classIcon"></i></div>
      </a>
      <div class="dropdown-menu" :class="[dropdown_menu_alignment]">
        <slot></slot>
      </div>
    </li>
    <li class="dropdown-submenu" v-else>
      <a class="dropdown-item" :class="[dropdown_icon]" href="#" role="button" aria-haspopup="true"
         aria-expanded="false"
         :style="{'cursor':cursor}"
         @click.prevent="showSubmenu = !showSubmenu"
      >
        {{ label }} <i :class="[classIcon]" v-show="classIcon"></i>
      </a>
      <div class="dropdown-menu" :class="[dropdown_menu_alignment]" v-if="showSubmenu">
        <slot></slot>
      </div>
    </li>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "menu-item-dropdown",
  mixins: [checkPermissions],
  props: {
    customStyle: {
      default: null
    },
    cursor: {
      type: String,
      default: 'pointer'
    },
    openInHover: {
      type: Boolean,
      default: false
    },
    isSubmenu: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    drop: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: null
    },
    label: {
      type: String
    },
    classIcon: {
      type: String,
      default: null
    },
    userMenu: {
      type: Boolean,
      default: false
    },
    userIcon: {
      type: String
    },
    showAltIcon: {
      type: Boolean,
      default: false
    },
    altUserIcon: {
      type: String
    },
    iconStyle: {
      type: String,
      default: ''
    }
  },
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    dropdown_menu_alignment: function () {
      return this.align == "right" ? 'dropdown-menu-right' : ''
    },
    dropdown_icon: function () {
      return this.showIcon ? 'dropdown-toggle' : 'dropdown-toggle caret-off'
    },
    dropdown_drop: function () {
      switch (this.drop) {
        case "left":
          return 'dropleft';
          break;
        case "right":
          return 'dropright';
          break;
        case "up":
          return 'dropup';
          break;
        default:
          return '';
          break;
      }
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  data() {
    return {
      showSubmenu: false
    }
  },
  mounted() {
    $('.dropdown-menu').click(function (e) {
      e.stopPropagation();
    });
  },
}
</script>

<style scoped>
.caret-off::before {
  display: none;
}

.caret-off::after {
  display: none;
}

.dropdown-hover:hover .dropdown-menu {
  display: block;
}

.nav-tabs .dropdown-menu,
.nav-pills .dropdown-menu,
.navbar .dropdown-menu {
  margin-top: 0;
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px;
  display: block !important;
}

/*
  This goes in the above class for hover, and the diplay code above goes in the :hover class below
  display: none !important;
*/

.dropdown-submenu:hover > .dropdown-menu {
}

.dropdown-submenu > a:hover:after {
  text-decoration: underline;
  transform: rotate(-90deg);
}

.mobile-padding {
  padding: .5rem 5px !important;
}

</style>
